<template>
  <div>
    <v-snackbar v-model="hideActionsTable" :timeout="0" :multi-line="true">
      Sort data
      <v-card-actions v-if="sort_data == true">
        <v-btn
          @click="cancelSortData()"
          :loading="cancel_sort"
          :disabled="cancel_sort || sorting_data || fetching"
          color="red"
          dark
          >Cancel</v-btn
        >
        <!-- v-if="sort_data == true" -->
        <v-btn
          @click="saveSort()"
          :loading="sorting_data"
          :disabled="sorting_data || cancel_sort || fetching"
          color="green"
          dark
          >Apply sort</v-btn
        >
        <label v-if="sort_msg == 3">Can't sort</label>
        <!-- v-else-if="sort_data == true" -->
      </v-card-actions>
    </v-snackbar>
    <h1 class="text-pagename">
      Product list {{ store_name != null ? " in " + store_name : null }}
    </h1>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      :to="
        '/weserve_admin_login/control/' +
        $store.state.backOffice.province +
        '/storeandproduct/store/' +
        $store.state.storeBack.store_detail_id +
        '/product/-1/id/0'
      "
      @click="toAdd()"
      v-if="sort_data == false && !isEditProductList"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <storeProductForm
      :dialog="productDialog"
      @setDialog="productDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :form="form"
      @addProduct="addProduct()"
      :original_data="original_data"
      :fetching_data="fetching_data"
      @setFetchingData="fetching_data = $event"
      @fetchData="fetching = $event"
    />
    <v-layout row wrap v-if="sort_data == false">
      <v-flex xs6 class="text-xs-left">
        <v-toolbar dense flat>
          <v-btn
            @click="startSort()"
            v-if="sort_data == false && !isEditProductList"
            :disabled="
              search != '' ||
              selected_type != 0 ||
              fetching ||
              search_by_status != 99
            "
            round
            dark
            >Start sort</v-btn
          >
        </v-toolbar>
      </v-flex>
      <v-flex xs6>
        <v-toolbar dense flat>
          <v-flex xs8>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Name / Price / Approve status"
              single-line
              hide-details
              style="padding: 0"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-select
              prepend-icon="search"
              label="Product status"
              v-model="search_by_status"
              item-text="name"
              item-value="value"
              :items="[
                { name: 'All', value: 99 },
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
              ]"
            ></v-select>
          </v-flex>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-card class="mx-2 mt-2">
      <v-card-text>
        <v-layout row wrap class="text-xs-left">
          <v-btn
            :disabled="
              sorting_data || cancel_sort || selected_type == 0 || fetching
            "
            color="primary"
            class="black--text"
            @click="filterType(0)"
            >All</v-btn
          >
          <draggable
            :list="product_type_list"
            :disabled="!sort_data"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
          >
            <v-btn
              :disabled="
                sorting_data ||
                cancel_sort ||
                selected_type == info.product_type_id ||
                fetching
              "
              v-for="info in product_type_list"
              :key="info.product_type_id"
              @click="filterType(info.product_type_id)"
            >
              <v-icon v-if="sort_data == true">drag_indicator</v-icon>
              {{ info.product_type_name_th }}
            </v-btn>
          </draggable>
        </v-layout>
      </v-card-text>
      <v-divider v-if="sort_data == true" />
    </v-card>
    <v-data-table
      :loading="fetching"
      :search="search"
      :headers="headers"
      :items="filterdProduct"
      :hide-actions="hideActionsTable"
      :pagination.sync="pagination"
    >
      <!-- product_list -->
      <template slot="items" slot-scope="props">
        <td class="px-1 handle" style="width: 0.1%" v-if="sort_data == true">
          <v-btn style="cursor: move" icon :disabled="sorting_data">
            <v-icon>drag_indicator</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center" v-else>{{ countIndex(props.item) }}</td>
        <td class="text-xs-center">{{ props.item.product_code }}</td>
        <td style="padding: 6px 0 0 0; position: relative">
          <span
            class="ribbon-rec elevation-1"
            v-if="
              props.item.product_recommend && !props.item.product_best_seller
            "
            >{{ props.item.product_recommend ? "Recommend" : null }}</span
          >
          <span
            class="ribbon-best elevation-1"
            v-if="
              props.item.product_best_seller && !props.item.product_recommend
            "
            >{{ props.item.product_best_seller ? "Best seller" : null }}</span
          >
          <span style="position: absolute">
            <span
              class="ribbon-rec elevation-1"
              v-if="
                props.item.product_recommend && props.item.product_best_seller
              "
              >{{ props.item.product_recommend ? "Recommend" : null }}</span
            >
            <span
              class="ribbon-best elevation-1 mt-4"
              v-if="
                props.item.product_recommend && props.item.product_best_seller
              "
              >{{ props.item.product_best_seller ? "Best seller" : null }}</span
            >
          </span>
          <img :src="props.item.product_image" width="100px" height="100px" />
        </td>
        <td class="text-xs-left">
          {{ props.item.product_name_th }}
          <br />
          <span style="color: grey; font-size: 12px">{{
            props.item.product_name_en
          }}</span>
        </td>
        <td class="text-xs-center">
          {{ parseFloat(props.item.product_sale_price).toFixed(2) }}
        </td>
        <td class="text-xs-center">
          {{ parseFloat(props.item.product_base_price).toFixed(2) }}
        </td>
        <td class="text-xs-center">
          <v-switch
            :disabled="isEditProductList"
            @change="deActivate(props.item)"
            v-model="props.item.product_status"
            color="primary"
            class="mt-2"
            style="max-width: 50px"
          ></v-switch>
        </td>
        <td
          class="text-xs-center green--text"
          v-if="props.item.product_approve != 0"
        >
          {{ checkApprove(props.item) }}
        </td>
        <td
          style="padding: 0"
          v-else-if="
            props.item.product_approve == 0 || props.item.product_approve == 1
          "
        >
          {{ checkApprove(props.item) }}
          <v-btn
            small
            color="primary"
            class="black--text"
            @click="goOnline(props.item)"
            >go online</v-btn
          >
        </td>

        <td class="px-0">
          <v-btn
            small
            :disabled="dupplitcating_product || isEditProductList"
            :loading="dupplitcating_product"
            icon
            @click="
              dupplicateProduct(props.item, filterdProduct.indexOf(props.item))
            "
            v-if="sort_data == false"
          >
            <v-icon small>file_copy</v-icon>
          </v-btn>

          <v-btn
            small
            :to="
              '/weserve_admin_login/control/' +
              $store.state.backOffice.province +
              '/storeandproduct/store/' +
              $store.state.storeBack.store_detail_id +
              '/product/' +
              props.index +
              '/id/' +
              props.item.product_id
            "
            icon
            @click="editProduct(props.item, props.index)"
            v-if="sort_data == false"
          >
            <v-icon small>{{
              isEditProductList ? "remove_red_eye" : "edit"
            }}</v-icon>
          </v-btn>

          <v-btn
            small
            icon
            @click="delProductList(props.item)"
            :disabled="isEditProductList"
            v-if="sort_data == false"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center px-3" v-if="fetching == true">
          Loading ...
        </div>
        <label v-if="fetching == false">No data available</label>
        <br />
        <v-btn
          @click="initialize()"
          v-if="fetching == false && selected_type == 0"
          >Reset</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Sortable from "sortablejs";
import storeProductForm from "./StoreProductForm.vue";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    confirm_dialog_dup: false,
    confirm_dialog_del: false,
    dupplitcating_product: false,
    search_by_status: 99,
    selected_type: 0,
    enabled: true,
    data_for_sort: {},
    sort_data: false,
    sort_msg: 0,
    cancel_sort: false,
    sorting_data: false,
    search: "",
    fetching_data: false,
    original_data: null,
    form: null,
    fetching: false,
    productDialog: false,
    dialog: false,
    editedIndex: -1,
    hideActionsTable: false,
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Product Code",
        align: "center",
        value: "product_code",
        sortable: false,
      },
      {
        text: "Image",
        align: "center",
        value: "img",
        sortable: false,
      },
      {
        text: "Product Name",
        align: "center",
        value: "product_name",
        sortable: false,
      },
      {
        text: "Sale Price",
        align: "center",
        value: "product_sale_price",
        sortable: false,
      },
      {
        text: "Base Price",
        align: "center",
        value: "product_base_price",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "product_status",
        sortable: false,
      },
      {
        text: "Approve",
        align: "center",
        value: "product_approve_name",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "action",
        sortable: false,
      },
    ],
  }),
  components: {
    draggable,
    storeProductForm,
  },
  computed: {
    ...mapState({
      store_name: (state) => state.storeBack.store_name,
      store_detail_id: (state) => state.storeBack.store_detail_id,
      product_type_list: (state) =>
        state.fetchProductTypeBack.product_type_list,
      product_list_pagination: (state) =>
        state.fetchProductListBack.product_list_pagination,
    }),
    ...mapGetters({
      product_list: "fetchProductListBack/productListTable",
      isEditProductList: "isEditProductList",
    }),
    filterdProduct() {
      if (this.search_by_status == 99) {
        return this.product_list;
      } else {
        return this.product_list.filter((value) => {
          return value.product_status == this.search_by_status;
        });
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    pagination() {
      if (this.hideActionsTable == false) {
        this.$store.commit(
          "fetchProductListBack/setProductListPagination",
          this.pagination
        );
      }
    },
  },

  created() {
    this.initPageTable();
    this.setForm();
    this.initialize();
  },
  mounted() {
    let table = document.querySelector(".v-datatable tbody");
    const _self = this;
    Sortable.create(table, {
      handle: ".handle",
      onEnd({ oldIndex, newIndex }) {
        const rowSelected = _self.data_for_sort.product.splice(oldIndex, 1)[0];
        _self.data_for_sort.product.splice(newIndex, 0, rowSelected);
      },
    });
  },
  methods: {
    initPageTable() {
      this.pagination = JSON.parse(
        JSON.stringify(this.product_list_pagination)
      );
    },
    async deActivate(item) {
      let clone_item = JSON.parse(JSON.stringify(item));
      delete clone_item.product_approve_name;
      delete clone_item.product_image;
      let send_data = {
        product_id: clone_item.product_id,
        data: { product_status: clone_item.product_status },
      };
      const check_success = await this.$store.dispatch(
        "fetchProductListBack/deActivate",
        send_data
      );
      if (check_success == false) {
        item.product_status = !item.product_status;
      }
    },
    async dupplicateProduct(item, index) {
      let n = await this.$confirm("Do you want to duplicate this product ?");

      if (n == true) {
        this.dupplitcating_product = true;
        let product_detail = await this.$store.dispatch(
          "fetchProductListBack/getProductDetail",
          item.product_id
        );
        delete product_detail.product_id;
        for (let val of product_detail.product_option) {
          delete val.option_id;
          for (let val2 of val.option_choice) {
            delete val2.choice_id;
          }
        }
        if (product_detail.product_name_th != null) {
          product_detail.product_name_th =
            product_detail.product_name_th + "_copy";
        } else if (product_detail.product_name_en != null) {
          product_detail.product_name_en =
            product_detail.product_name_en + "_copy";
        } else if (product_detail.product_name_cn != null) {
          product_detail.product_name_cn =
            product_detail.product_name_cn + "_copy";
        }
        delete product_detail.product_image;
        product_detail.product_approve = 0;
        product_detail.product_status = false;
        let product_added = await this.$store.dispatch(
          "fetchProductListBack/addProductList",
          product_detail
        );
        this.$store.commit("fetchProductListBack/dupplicateProduct", {
          index,
          product_added,
        });

        let new_series = {};
        new_series.product_type = JSON.parse(
          JSON.stringify(this.product_type_list)
        );

        new_series.product = JSON.parse(JSON.stringify(this.product_list));
        let obj1 = await this.setSortData(new_series);
        await this.$store.dispatch(
          "fetchProductListBack/sortProductList",
          obj1
        );
        this.dupplitcating_product = false;
      }
    },
    countIndex(item) {
      return this.product_list.indexOf(item) + 1;
    },
    async filterType(type_id) {
      if (this.sort_data == false) {
        this.selected_type = type_id;
        if (type_id == 0) {
          this.fetching = true;
          await this.$store.dispatch("fetchProductListBack/getData");
          this.fetching = false;
        } else {
          this.fetching = true;
          await this.$store.dispatch(
            "fetchProductListBack/getProductByType",
            type_id
          );
          this.fetching = false;
        }
      }
    },
    async startSort() {
      this.hideActionsTable = true;
      this.pagination.rowsPerPage = -1;
      this.data_for_sort.product = JSON.parse(
        JSON.stringify(this.product_list)
      );
      this.sort_data = true;
    },
    async cancelSortData() {
      this.cancel_sort = true;

      await this.fetchNewData();
      this.cancel_sort = false;
      this.data_for_sort = {};
      this.sort_data = false;
      this.sort_msg = 0;
      this.hideActionsTable = false;
      this.pagination.rowsPerPage = 10;
      this.pagination.page = 1;
      this.$store.commit(
        "fetchProductListBack/setProductListPagination",
        this.pagination
      );
    },
    async setSortData(data) {
      let obj1 = JSON.parse(JSON.stringify(data));
      for (let key in obj1.product) {
        for (let x in obj1.product[key]) {
          if (x != "product_id" && x != "product_series") {
            delete obj1.product[key][x];
          }
        }
        obj1.product[key].product_series = parseFloat(key) + 1;
      }
      for (let key in obj1.product_type) {
        for (let x in obj1.product_type[key]) {
          if (x != "product_type_id" && x != "product_type_series") {
            delete obj1.product_type[key][x];
          }
        }
        obj1.product_type[key].product_type_series = parseFloat(key) + 1;
      }
      return obj1;
    },
    async saveSort() {
      this.sorting_data = true;
      this.data_for_sort.product_type = JSON.parse(
        JSON.stringify(this.product_type_list)
      );
      let obj1 = await this.setSortData(this.data_for_sort);
      this.sort_msg = await this.$store.dispatch(
        "fetchProductListBack/sortProductList",
        obj1
      );
      if (this.sort_msg != 3) {
        await this.fetchNewData();
        this.sort_data = false;
        this.hideActionsTable = false;
      }
      this.sorting_data = false;
    },
    addProduct() {
      this.setForm();
    },
    toAdd() {
      this.setForm();
      // this.productDialog = true;
    },
    setForm() {
      this.form = {
        product_code: null,
        product_image: null,
        product_name_th: null,
        product_description_th: null,
        product_name_en: null,
        product_description_en: null,
        product_name_cn: null,
        product_description_cn: null,
        product_sale_price: null,
        product_base_price: null,
        product_note: null,
        product_type_id: null,
        product_recommend: false,
        product_best_seller: false,
        product_approve: 0,
        product_status: false,
        product_store_id: this.store_detail_id,
        product_option: [],
      };
    },
    async delProductList(item) {
      let n = await this.$confirm("Do you want to delete this product ?");
      if (n == true) {
        this.$store.dispatch("fetchProductListBack/delProductList", item);
      }
    },
    goOnline(item) {
      this.$store.dispatch("fetchProductListBack/onWebProduct", item);
    },
    checkApprove(item) {
      if (item.product_approve == 1) {
        item.product_approve_name = "Pending";
      } else if (item.product_approve == 2) {
        item.product_approve_name = "Online";
      } else if (item.product_approve == 0) {
        item.product_approve_name = "Offline";
      }
      return item.product_approve_name;
    },
    async fetchNewData() {
      this.fetching = true;
      this.$store.commit("fetchProductTypeBack/getData", []);
      this.$store.commit("fetchProductListBack/getData", []);
      this.$store.dispatch("fetchProductTypeBack/getData");
      await this.$store.dispatch("fetchProductListBack/getData");
      this.fetching = false;
    },
    async initialize() {
      this.fetching = true;
      if (this.store_detail_id == null) {
        let store_detail = await this.$store.dispatch(
          "fetchStoreBack/getStoreDetail",
          this.$route.params.store_id
        );
        this.$store.commit(
          "storeBack/setStoreDetailId",
          store_detail.store.store_id
        );
      }
      this.$store.dispatch("fetchProductTypeBack/getData");
      await this.$store.dispatch("fetchProductListBack/getData");
      this.fetching = false;
    },
    async editProduct(item, index) {
      // this.form = {};
      this.editedIndex = index;
      // this.fetching_data = true;
      // let get_data = await this.$store.dispatch(
      //   "fetchProductListBack/getProductDetail",
      //   item.product_id
      // );
      // this.fetching_data = false;
      // this.original_data = Object.assign({}, get_data);
      // this.form = get_data;
    },
  },
};
</script>
<style scoped>
.ribbon-rec {
  background-color: rgba(255, 255, 255, 0.817);
  color: black;
  padding: 1px 5px;
  margin-top: 3px;
  position: absolute;
  border-radius: 0px 2px 2px 0px;
}
.ribbon-best {
  background-color: #ffd500c2;
  color: black;
  padding: 1px 5px;
  margin-top: 3px;
  position: absolute;
  width: 70px;
  border-radius: 0px 2px 2px 0px;
}
</style>


